import { TreeHeaders } from './tree-demo.model';

export enum TreeDemoEnum {
  EDIT = 'Edit',
  DOUBLE = 'Double',
  DELETE = 'Delete',
  ADD_VISIBILITY = 'add',
  ADD_FROM_BUTTON = 'AddFromButton'
}

export const TreeHeader: TreeHeaders[] = [
  {
    field: 'label',
    header: '',
    sortable: false
  }
];

export const TreeDemoData = {
  content: [
    {
      label: 'Node 1',
      collapsedIcon: 'fa fa-folder-o fa-lg',
      expandedIcon: 'fa fa-folder-open-o fa-lg',
      children: [
        {
          label: 'Node 1.1',
          collapsedIcon: 'fa fa-folder-o fa-lg',
          expandedIcon: 'fa fa-folder-open-o fa-lg',
          children: [
            {
              label: 'Node 1.1.1',
              collapsedIcon: 'fa fa-archive fa-lg',
              isLastNode: true
            },
            {
              label: 'Node 1.1.2',
              collapsedIcon: 'fa fa-archive fa-lg',
              isLastNode: true
            }
          ]
        },
        {
          label: 'Node 1.2',
          collapsedIcon: 'fa fa-archive fa-lg',
          isLastNode: true
        }
      ]
    },
    {
      label: 'Node 2',
      collapsedIcon: 'fa fa-folder-o fa-lg',
      expandedIcon: 'fa fa-folder-open-o fa-lg',
      children: [
        {
          label: 'Node 2.1',
          collapsedIcon: 'fa fa-archive fa-lg',
          isLastNode: true
        },
        {
          label: 'Node 2.2',
          collapsedIcon: 'fa fa-archive fa-lg',
          isLastNode: true
        }
      ]
    }
  ]
};
